<template>
  <div>
  <div class="popup_wrap protocol_detail" v-show="visible">
    <div class="popup_title">
      <p><span id="node_title" v-html='"\"" + protocolName?.replace(/<[^>]*>?/g, "") + "\"&nbsp;프로토콜"'>
                </span></p>
      <a>
        <div id="popup_close" class="btn_close" title="Close" @click="close">
          <div class="btn_close_box"><span></span><span></span></div>
        </div>
      </a>
    </div><!-- //popup_title -->
    <div class="popup_content" :key="forceReRender">
      <div class="popup_content_fix_top">
        <div class="protocol_detailtop">
          <ul class="protocol_detailtop_tab">
            <li :class="pageType == tabTypeList[0] ? 'on' : null" @click="tabSelectFunc(0)">
              <a class="icon1" href="javascript:void(0);">트리보기</a>
            </li>
            <li :class="pageType == tabTypeList[1] ? 'on' : null" @click="tabSelectFunc(1)">
              <a class="icon2" href="javascript:void(0);">위키보기</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="popup_content1" v-show="pageType == tabTypeList[0]">
        <div class="tree" id="tree-protocol"></div>
      </div>
      <div class="popup_content2" v-show="pageType == tabTypeList[1]">
        <div class="wiki_container">
          <div class="wiki_sidebar" v-if="showWikiIndex">
            <WikiIndex v-if="wikiIndex" :indexList="titleIndex" :scrollMode="true"
                       @itemSelect="checkTitlePosition"
                       @mounted="data=>bookmarkInfo=data"></WikiIndex>
          </div>
          <div class="wiki_content" :class="{'full-width': !showWikiIndex}">
            <div class="wiki_content_inner" ref="wikiWrap" @scroll="moveScroll">
              <Process v-if="isProcess.isProcess"
                       :item="isProcess"
                       @load-content="(status) => awaitContent('process', status)"
              ></Process>
              <Keyword v-if="isKeyword.isKeyword"
                       :item="isKeyword"
                       :readonly="true"
                       @load-content="(status) => awaitContent('keyword', status)"
              ></Keyword>
              <WikiContent v-for="data in nodeData" :key="data.id || data.key" :editor="data"></WikiContent>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="popup_footer">
    </div>
    <Loading :visible="loading"/>
  </div>
  <div class="mask_wrap" style="display:block;" v-if="visible"></div>
  </div>
</template>

<script>
  import CommNew from "@processEditor/CommNew";
  import Process from '@components/protocolEditor/wikiProcess.vue'
  import Keyword from '@components/protocolEditor/wikiKeyword.vue'
  import WikiIndex from '@components/protocolEditor/wikiIndex.vue'
  import WikiContent from '@components/platform_new/wikiViewerContents.vue'
  import Loading from '@common/loading.vue';

  import {createNamespacedHelpers} from 'vuex';

  const Hub = createNamespacedHelpers('Hub');
  import {typeOfJson} from "@processEditor/CommNew";
  import MakeNodesInfomation from '@components/platform_new/wikiApi.js'
  import {
    go,
    goMake,
    makePanel,
    makeTextBlock,
    makeExpanderButton,
    setCommitNodes,
    linkTemplate
  } from '@mixins/protocolTemplate.js'

  const makeNodes = new MakeNodesInfomation();

  export default {
    name: "protocolDetail",
    mixins: [CommNew],
    data() {
      return {
        protocolType: null,
        isProcess: false,
        isKeyword: false,
        titleIndex: [],
        nodeData: [],
        titleRefs: [],
        bookmarkInfo: null,
        scrollTimer: null,
        scrollTopPoint: 0,
        loading: false,
        protocolName: "",
        awaitContentStatus: {
          'process': false,
          'keyword': false,
          'content': false
        },
        visible: false,
        wikiIndex: true,
        forceReRender: 0,
        tabTypeList: ["tree", "wiki"],
        pageType: null,
        diagram: null,
        lastScrollData: null,
        lastBookmarkSelectTime: null,
        showWikiIndex: true,
      }
    },
    components: {Process, Keyword, WikiContent, WikiIndex, Loading},
    computed: {
      ...Hub.mapGetters(
          [
            'getProtocolDetailObj'
          ]),
    },
    watch: {
      getProtocolDetailObj: {
        deep: true,
        async handler(value) {
          if (value.protocolDetailPopFlag === true && typeof value.protocolDetailData == 'object') {
            this.Data = value.protocolDetailData;
            this.show();
          } else if (value.protocolDetailPopFlag === false) {
            await this.resetData();
            this.forceReRender++;
            this.visible = false;
          }
        }
      },
      pageType: {
        deep: true,
        async handler(value) {
          if(value == null) return;
          if (this.pageType == this.tabTypeList[0]) {
            this.initDiagram();
            if (Array.isArray(this.issue)) {
              this.setModel(this.issue);
            }
          } else if (this.pageType == this.tabTypeList[1]) {
            this.forceReRender++
          }
        }
      },
    },
    async mounted() {
      this.updateWikiIndexVisibility();
      window.addEventListener('resize', this.updateWikiIndexVisibility);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.updateWikiIndexVisibility);
    },
    methods: {
      ...Hub.mapMutations(
          [
            'setProtocolDetailObj',
          ]
      ),
      async show() {
        this.loading = true;
        if (this.Data.protocolId) {
          await this.loadProtocol();
          if(this.Data.pageType){
            this.pageType = this.Data.pageType;
          }
          if(!this.pageType){
            this.tabSelectFunc(0);
          }
        } else {
          this.awaitContent('content', false);
        }
        this.loading = false;
        this.visible = true;
      },
      close() {
        this.setProtocolDetailObj({
          openFlag: false,
          dataObj: {}
        });
      },
      bodyHeight() {
        const app = document.getElementById("app");
        app.classList.add("height-auto");
        document.body.classList.add("height-auto")
      },
      awaitContent(key, status) {
        this.awaitContentStatus[key] = status;
        if (this.protocolType == 'UNIT' && this.awaitContentStatus['content'] == true) {
          this.$emit('load-content', {status: true, contentStatus: this.awaitContentStatus});
          return
        }
        if (status === true) {
          this.$emit('load-content', {status, contentStatus: this.awaitContentStatus});
        }
        return status
      },
      objectToURLParams(obj) {
        return Object.entries(obj)
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join('&');
      },
      async loadProtocol() {
        this.loading = true;
        const onlyProtocolId = this.Data.protocolId;
        let findOnlyProtocolData = await this.$wApi.protocol.searchForProtocoId({
          protocolId: onlyProtocolId,
          isMemo: true,
          isConent: true,
          isComment: true,
          isPublish: this.Data.isPublish ? 1 : 0,
        });
        if (findOnlyProtocolData?.error || findOnlyProtocolData == null || findOnlyProtocolData?.length == 0) {
          this.loading = false;
          this.close();
          window.alert("서버와 통신중 오류가 발생했습니다.<br>잠시후 다시 시도해 주세요.");
          return;
        }
        const onlyProtocolDetail = Array.isArray(findOnlyProtocolData) ? findOnlyProtocolData[0] : findOnlyProtocolData;
        this.protocolName = onlyProtocolDetail.name;
        this.issue = null;
        this.protocolType = onlyProtocolDetail.protocolType;
        makeNodes.setNodeContents = typeOfJson(onlyProtocolDetail.nodeContent);
        this.nodeData = [];
        const protocolJson = typeOfJson(onlyProtocolDetail.json);
        this.Data.json = protocolJson;
        this.issue = Array.isArray(protocolJson?.issues) ? protocolJson.issues : [];
        this.issue.forEach((item) => {
          if (item.category === 'SHORTVALUE') item.display = false;
        });
        if (this.issue.length === 0) {
          this.loading = false;
          this.close();
          window.alert("프로토콜 상세 내용이 존재하지 않습니다.");
          return;
        }
        let nodeDatas = makeNodes.makeNodeList(JSON.parse(JSON.stringify(this.issue)));

        this.titleIndex = [];

        nodeDatas[0].child.map((item) => {
          if (item.hasOwnProperty('isProcess')) {
            this.isProcess = item
            this.isProcess.processId = this.Data.processId;
            this.isProcess.protocolId = this.Data.protocolId
            this.titleIndex.push(item);
          }
          if (item.hasOwnProperty('isKeyword')) {
            this.isKeyword = item
            this.titleIndex.push(item);
          }
        })

        this.nodeData = await makeNodes.makeListData(nodeDatas[0].child);

        for (let item of this.nodeData) {
          if (item.step <= 0) {
            this.titleIndex.push(item);
          }
        }
        if (this.Data.TAKey) {
          this.bodyHeight();
        }
        await this.$nextTick();
        this.titleRefs = this.$refs.wikiWrap.querySelectorAll('[data-depth="0"]');
        if (this.titleRefs.length > 0) {
          this.scrollTopPoint = this.titleRefs[0].getBoundingClientRect();
        }
        this.awaitContent('content', true);
        this.loading = false;
      },
      checkTitlePosition(info) {
        if (!info || !this.titleRefs || this.titleRefs.length === 0) return

        this.lastBookmarkSelectTime = Date.now();

        const targetElement = this.titleRefs[info.index];
        if (targetElement) {
          const offset = targetElement.offsetTop;
          const containerElement = this.$refs.wikiWrap;
          const marginTop = 0;
          const start = containerElement.scrollTop;
          const end = offset - containerElement.offsetTop - marginTop;
          let change = 0;
          let position = start;
          let intervalEndTime = 150;
          let intervalTime = 5;
          const division = intervalEndTime / intervalTime;
          try {
            if (start < end) {
              change = end - start;
              const changeScroll = setInterval(function () {
                containerElement.scrollTop = position = position + change / division;
              }, intervalTime);
              setTimeout(function () {
                clearInterval(changeScroll);
              }, intervalEndTime);
            } else if (start > end) {
              change = start - end;
              const changeScroll = setInterval(function () {
                containerElement.scrollTop = position = position - change / division;
              }, intervalTime);
              setTimeout(function () {
                clearInterval(changeScroll);
              }, intervalEndTime);
            } else {
              return;
            }
          } catch (e) {
            containerElement.scrollTop = end;
            clearInterval();
          }
        }
      },
      moveScroll(e) {
        if (!this.wikiIndex || this.wikiIndex.length == 0) return;

        const currentTime = Date.now();
        const currentScrollTop = this.$refs.wikiWrap.scrollTop;

        if (this.lastBookmarkSelectTime && (currentTime - this.lastBookmarkSelectTime) < 200) {
          return;
        }

        if (this.lastScrollData) {
          const timeDiff = currentTime - this.lastScrollData.time;
          const scrollDiff = Math.abs(currentScrollTop - this.lastScrollData.scrollTop);
          const scrollSpeed = scrollDiff / timeDiff;

          if (scrollSpeed > 1.5) {
            this.lastScrollData = {time: currentTime, scrollTop: currentScrollTop};
            return;
          }
        }

        this.lastScrollData = {time: currentTime, scrollTop: currentScrollTop};

        clearTimeout(this.scrollTimer);

        this.scrollTimer = setTimeout(() => {
          const scrollTop = this.$refs.wikiWrap.scrollTop;
          const containerTop = this.$refs.wikiWrap.getBoundingClientRect().top;

          let activeIndex = 0;
          let currentSelectedIndex = this.bookmarkInfo.currentIndex || 0;

          for (let i = 0; i < this.titleRefs.length; i++) {
            const element = this.titleRefs[i];
            const rect = element.getBoundingClientRect();
            const relativeTop = rect.top - containerTop;

            if (relativeTop <= 100) {
              activeIndex = i;
            } else {
              break;
            }
          }

          if (currentSelectedIndex !== activeIndex) {
            this.bookmarkInfo.handler.select(activeIndex);
          }

        }, 100);
      },
      initDiagram() {
        this.diagram = new go.Diagram("tree-protocol",
            {
              isReadOnly: true,
              layout: goMake(go.TreeLayout,
                  {
                    isOngoing: true,
                    isInitial: true,
                    nodeSpacing: 8,
                  }
              ),
              "undoManager.isEnabled": true,
              scale: 1,
              maxScale: 3,
              minScale: 0.2,
              nodeTemplate: goMake(go.Node, "Spot",
                  {
                    selectionObjectName: "PANEL",
                  },
                  new go.Binding('visible', 'data', (data) => {
                    let visible = true;
                    if (data.H == true) {
                      visible = false;
                    }

                    if (data.display !== undefined && data.display === false) {
                      visible = false;
                    }

                    return visible;
                  }).ofObject(),
                  makePanel({}, {}, [makeTextBlock()]),
                  makeExpanderButton(),
              ),
              linkTemplate: linkTemplate()
            },
        )
      },
      setModel(data) {
        if (!this.diagram || !Array.isArray(data)) return;
        this.diagram.model = new go.TreeModel(data);
        setCommitNodes(this.diagram, data);
        let hiddenList = [];
        data.forEach(nodeData => {
          if (nodeData.H === true) {
            hiddenList.push(nodeData);
          }
        });
        for (let hiddenNode of hiddenList) {
          let parentNode = this.diagram.findNodeForKey(hiddenNode.key);
          let childrenNodes = this.findAllTreeChildrenNodes(parentNode);
          childrenNodes.map(async (childNode) => {
            childNode.visible = false;
          });
        }
      },
      findAllTreeChildrenNodes(node) {
        let children = new go.Set();

        function findChildNodes(currentNode, childrenSet) {
          if (currentNode) {
            currentNode.findLinksOutOf().each((link) => {
              const childNode = link.getOtherNode(currentNode);
              if (!childrenSet.contains(childNode)) {
                childrenSet.add(childNode);
                findChildNodes(childNode, childrenSet);
              }
            });
          }
        }

        findChildNodes(node, children);

        return children;
      },
      tabSelectFunc(tabIndex) {
        this.pageType = this.tabTypeList[tabIndex];
      },
      updateWikiIndexVisibility() {
        this.showWikiIndex = window.innerWidth > 950;
      },
      async resetData() {
        this.protocolType = null;
        this.isProcess = false;
        this.isKeyword = false;
        this.titleIndex = [];
        this.nodeData = [];
        this.titleRefs = [];
        this.bookmarkInfo = null;
        this.scrollTimer = null;
        this.scrollTopPoint = 0;
        this.loading = false;
        this.protocolName = "";
        this.awaitContentStatus = {
          'process': false,
          'keyword': false,
          'content': false
        };
        this.visible = false;
        this.wikiIndex = true;
        this.forceReRender = 0;
        this.tabTypeList = ["tree", "wiki"];
        this.pageType = null;
        this.diagram = null;
      }
    }
  }
</script>

<style lang="scss">
  @import "@/style/new/css/cyl.common.css";

  .protocol_detail {
    display: block;
    position: fixed;
    width: 1200px;
    height: 85%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    box-shadow: 5px 5px 20px 0px rgba(0, 0, 0, 0.2);

    .popup_content {
      height: calc(100% - 100px);
      padding: 10px;

      .popup_content_fix_top {
        justify-content: left;
        padding:5px;
      }

      .popup_content1 {
        height: calc(100% - 80px);

        .tree {
          height: 100% !important;
        }
      }

      .popup_content2 {
        height: calc(100% - 80px);

        .wiki_container {
          display: flex;
          height: 100%;

          .wiki_sidebar {
            width: 18.5%;
            min-width: 200px;
            background: #f8f9fa;
            border-right: 1px solid #e9ecef;
            overflow-y: auto;

            .protocol_detail_list_area {
              display: block;
            }
          }

          .wiki_content {
            flex: 1;
            overflow: hidden;

            &.full-width {
              width: 100%;
            }

            .wiki_content_inner {
              height: 100%;
              overflow-y: auto;
              padding: 20px;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 1200px) {
    .protocol_detail {
      width: 95%;
      .popup_content2 {
        .wiki_sidebar {
          .protocol_detail_list_area {
            display: none;
          }
        }
      }
    }
  }
</style>
